import * as type from "../types";

const initialState = {
  activeCompany: null,
  loading: true,
};

export const activeCompany = (state = initialState, payload) => {
  switch (payload.type) {
    case type.SET_ACTIVE_COMPANY:
      return {
        ...state,
        activeCompany: payload.company,
        loading: false,
      };
    case type.UPDATE_ACTIVE_COMPANY_NAME:
      return {
        ...state,
        activeCompany: {
          ...state.activeCompany,
          name: payload.name,
        },
      };
    default:
      return state;
  }
};
